export default __webpack_public_path__ + "static/border-mobile-f63694ad79c85bc0a2e3a8e94320ddb9.png";